<template>
	<div id="register-liga">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Duel</li>
      <li class="active">List Register Liga</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">List Register Liga</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading">
						<div class="pull-right">
              <button type="button" class="btn btn-success btn-xs m-r-5" @click="createRegisterLiga()"><span class="fa fa-plus"></span> Tambah Register Liga</button>
            </div>
            <h4 class="panel-title">List Register Liga</h4>
          </div>
          <div class="panel-body">
            <app-datatable 
              :items="registerLigaList" 
              :headers="headers"
							v-on:dblClicked="updateRegisterLiga()"
							v-on:deleted="deleteRegisterLiga($event)"
              v-on:selected="selectedRow = $event" 
            />
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>

<script>
import DuelService from '@/services/duel.js'
import DataTable from '@/components/plugins/DataTable'
import Spinner from '@/components/plugins/Spinner'
import Moment from 'moment'

export default {
	name: 'register-liga',
	components: {
		'app-datatable': DataTable,
		'app-spinner': Spinner,
	},
	data: function () {
		return {
			isLoading: false,
			registerLigaList: [],
			selectedRow: null,
			search: null,
			pagination: {
				perPage: 25,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc',
			},
			headers: ['Name', 'Started At', 'Ended At', 'Is Active'],
		}
	},
	mounted: function () {
		this.fetchData();
	},
	methods: {
		fetchData: function () {
			let datas = [
				{
					id: 1,
					name: 'Budi Setiawan',
					started_at: 1589353552000,
					ended_at: 1589353552000,
					is_active: 'True'
				},
				{
					id: 2,
					name: 'Budi Setiawan',
					started_at: 1589353552000,
					ended_at: 1589353552000,
					is_active: 'True'
				},
			];

			datas.forEach(data => {
				var row = {
					id: data.id,
					data: [
						data.name,
						Moment(data.started_at).format('YYYY-MM-DD'),
						Moment(data.ended_at).format('YYYY-MM-DD'),
						data.is_active,
					]
				}

				this.registerLigaList.push(row)
			})
		},
		createRegisterLiga: function () {
			this.$router.push({ path: '/register-liga/form' })
		},
		updateRegisterLiga: function () {
			var registerLigaId = this.selectedRow.id
			this.$router.push({ path: '/register-liga/form/', query: { id: registerLigaId } })
		},
		deleteRegisterLiga: function (register) {
			var registerLigaId = register.id
			var context = this
			var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?")
			if (confirmed) {
				this.isLoading = true
				DuelService.deleteRegisterLiga(registerLigaId, function (result) {
					if (result.success) {
						alert('Data Terhapus')
						context.fetchData()
						context.isLoading = false
					}
				})
			}
		},
	},
}
</script>


// WEBPACK FOOTER //
// RegisterLiga.vue?258cf97e